export default class InternalServerError extends Error {
	public constructor() {
		super();
	}
}
